<template>
  <button
    v-if="action && !current"
    :class="classObject"
    :data-number="number"
    class="progress-step"
    type="button"
    @click="action"
  >
    <span class="progress-step__text">
      <slot/>
    </span>
  </button>

  <div
    v-else
    :class="classObject"
    :data-number="number"
    class="progress-step"
  >
    <span
      v-if="current"
      class="sr-only"
    >
      Aktueller Schritt:
    </span>
    <span class="progress-step__text">
      <slot/>
    </span>
  </div>
</template>

<script>
import config from '@/config'

export default {
  name: 'AProgressStep',

  props: {
    action: {
      type: Function
    },
    current: {
      type: Boolean
    },
    number: {
      type: Number,
      required: true
    },
    status: {
      type: Number,
      validator (value) {
        return [
          config.status.ERROR,
          config.status.SUCCESS
        ].indexOf(value) >= 0
      }
    }
  },

  data () {
    return {
      classObject: {
        'has-icon has-error': this.status === this.$config.status.ERROR,
        'has-icon has-success': this.status === this.$config.status.SUCCESS,
        'is-current': this.current,
        'is-editable': this.action
      }
    }
  }
}
</script>

<style scoped>
.progress-step {
  display: flex;
  position: relative;
  align-items: center;
  margin: 0;
  padding: 6px;

  text-align: left;
  text-decoration: none;
  color: var(--color-text);

  background: none;
  border: 0;
  border-radius: 18px;

  transition: background-color 300ms;
}

.progress-step.is-current,
.progress-step.is-editable:hover,
.progress-step.is-editable:focus {
  background-color: var(--color-brand-pale);
}

.progress-step::before {
  content: attr(data-number);

  display: inline-flex;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
  width: 24px;
  height: 24px;

  font-weight: 400;
  color: #fff;

  background: var(--color-brand) center no-repeat;
  border-radius: 50%;

  opacity: 0.5;
}

.progress-step.has-icon::before,
.progress-step.is-current::before {
  opacity: 1;
}

.progress-step.has-icon::before {
  color: transparent;
}

.progress-step.has-error::before {
  background-color: var(--color-error);
  background-image: url("~@/assets/progress-error.svg");
  background-size: 6px;
}

.progress-step.has-success::before {
  background-color: var(--color-success);
  background-image: url("~@/assets/progress-success.svg");
  background-size: 14px;
}

.progress-step__text {
  margin: 0 5px 0 10px;
  line-height: 1.2;
}

@media (min-width: 900px) {
  .progress-step:not(.is-current) .progress-step__text {
    position: absolute;
    bottom: calc(100% + 10px);
    left: 50%;
    margin: 0;
    padding: 6px 10px;
    transform: translateX(-50%);
    z-index: var(--z-index-tooltip);

    visibility: hidden;
    opacity: 0;

    text-align: center;

    background-color: var(--color-brand-pale);
    border-radius: 16px;

    transition:
      visibility 300ms,
      opacity 300ms;
  }

  .progress-step:not(.is-current) .progress-step__text::after {
    content: "";

    position: absolute;
    width: 10px;
    height: 10px;
    bottom: -5px;
    left: 50%;
    transform: translateX(-50%) rotate(45deg);

    background-color: var(--color-brand-pale);
  }

  .progress-step:hover .progress-step__text,
  .progress-step:focus .progress-step__text {
    visibility: visible;
    opacity: 1;
  }
}
</style>
